import React from 'react'

export const useTelegramSignIn = () => {
  const [isSignedIn, setIsSignedIn] = React.useState(false)

  React.useEffect(() => {
    const hash = window.location.hash
    if (hash.startsWith('#tgWebAppData')) {
      // const initData = hash.replace('#tgWebAppData=', '')
      // TODO
      // send it to the server for verification
      setIsSignedIn(true)
    }
  }, [setIsSignedIn])

  return { isSignedIn }
}
